import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { getClassAssignments } from '@/lib/student-objectives/class-assignments';
import { ClassCard } from './class-card';

interface Props {
  studentId: string;
  onStartExercise: (exerciseId: string) => void;
  /** Exercice en cours d'ouverture (spinner sur son bouton). */
  pendingExerciseId?: string | null;
}

export function MaClasseSection({ studentId, onStartExercise, pendingExerciseId = null }: Props) {
  const { data: summaries = [], isLoading } = useQuery({
    queryKey: ['class-assignments', studentId],
    queryFn: () => getClassAssignments(supabase, studentId),
    staleTime: 60 * 1000,
  });

  if (isLoading || summaries.length === 0) return null;

  return (
    <section className="space-y-3">
      <h2 className="font-display text-ink-900 flex items-center gap-2 text-lg font-bold">
        <span aria-hidden>📚</span>
        <span>Ma classe</span>
      </h2>
      {summaries.map((s) => (
        <ClassCard
          key={s.classId}
          summary={s}
          onStartExercise={onStartExercise}
          pendingExerciseId={pendingExerciseId}
        />
      ))}
    </section>
  );
}
